<template>
    <v-card flat>
        <v-card-text>
            <v-container fluid>
                <v-form ref="form">
                    <v-row dense>
                        <v-col cols="12" sm="3">
                            <v-text-field label="Valor Asegurado *" color="textbox" v-model="obForm.valorAsegurado"
                                outlined :rules="_.concat(requeridoRegla,decimal)" dense />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field label="Prima Bruta *" color="textbox" v-model="obForm.prima_bruta"
                                outlined :rules="_.concat(requeridoRegla,decimal)" @keypress.native.enter="onListarImpuestos('L')" dense />
                        </v-col>
                        <v-col cols="12" sm="3" class="text-center">
                            <v-btn rounded color="secondary" dark @click="onListarImpuestos('L')">Calcular Prima</v-btn>
                        </v-col>
                        <v-col cols="12" sm="3"/>   
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="12">
                            <h3 class="subtitle-1 font-weight-bold">IMPUESTOS</h3>
                        </v-col>
                    </v-row>

                    <v-row dense v-for="(v,k) in obImpuestos" :key="`${_.uniqueId()}_${k}`">
                        <v-col cols="12" sm="3">
                            <h3 class="subtitle-1 text-right mt-2" v-html="v.nombre"></h3>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field color="textbox" v-model="v.monto" outlined disabled dense />
                        </v-col>
                        <v-col cols="12" sm="6"></v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="6">
                            <h3 class="subtitle-1 text-right mt-2 font-weight-bold">Total Impuestos</h3>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field color="textbox" v-model="totalImpuestos" outlined disabled dense />
                        </v-col>
                        <v-col cols="12" sm="3"/>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="12">
                            <h3 class="subtitle-1 font-weight-bold">OTROS</h3>
                        </v-col>
                    </v-row>

                    <v-row dense v-for="(v,k) in obOtros" :key="`${_.uniqueId()}_${k}`">
                        <v-col cols="12" sm="3">
                            <h3 class="subtitle-1 mt-2 text-right" v-html="v.nombre"></h3>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field color="textbox" v-model="v.valor_total" outlined disabled dense />
                        </v-col>
                        <v-col cols="12" sm="6"></v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="6">
                            <h3 class="subtitle-1 text-right mt-2 font-weight-bold">Total Otros</h3>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field color="textbox" v-model="totalOtros" outlined disabled dense />
                        </v-col>
                        <v-col cols="12" sm="3"/>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="6">
                            <h3 class="subtitle-1 text-right mt-2 font-weight-bold">Prima Total</h3>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field color="textbox" v-model="totalPrima" outlined disabled dense />
                        </v-col>
                        <v-col cols="12" sm="3"/>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="12" class="text-right">
                            <v-btn rounded outlined class="mr-1" 
                                   @click="setData('obForm.obImpuestos',obImpuestos);setData('obForm.obOtros',obOtros);setData('step',2)">Anterior</v-btn>
                            <v-btn rounded color="primary" @click="validar">Siguiente</v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: 'StepperDatosPrimaComponent',
        inject:['setData'],
        props:{
            load:{
                type:Boolean,
                default:false
            },
            obDatosPrincipal:{
                type:Object,
                default:{}
            },
            obImpuestos:{
                type:Array,
                default:() => []
            },
            obOtros:{
                type:Array,
                default:() => []
            },
            parametros:{
                type:Object,
                default:{}
            }
        },
        data: () => ({
            obForm:{
                valorAsegurado:0,
                prima_bruta:0
            }
        }),
        computed:{
            totalImpuestos(){
                var l = _.cloneDeep(_.toArray(this.obImpuestos));
                var sum = _.round(_.sumBy(l,'monto'),2);
                return _.isNaN(sum) ? 0 : sum;
            },
            totalOtros(){
                var l = _.cloneDeep(_.toArray(this.obOtros));
                var sum = _.round(_.sumBy(l,'valor_total'),2);
                return _.isNaN(sum) ? 0 : sum;
            },
            totalPrima(){
                var p = _.toNumber(this.obForm.prima_bruta) + this.totalImpuestos + this.totalOtros;
                return _.round(p,2);
            }
        },
        watch:{
            load(val){
                if(val && !_.isUndefined(this.obDatosPrincipal.idCertificado) && !_.isNull(this.obDatosPrincipal.idCertificado)){
                    this.obForm.valorAsegurado = Number.parseFloat(this.obDatosPrincipal.valorAsegurado).toFixed(2);
                    this.obForm.prima_bruta = Number.parseFloat(this.obDatosPrincipal.prima_valor_bruto).toFixed(2);
                    this.onListarPrima('L');
                }
            }
        },
        methods:{
            onListarPrima(ev){
                if(!_.isUndefined(ev)){
                    var error = 'E';
                    var o = { opcion:'LISTAR', idPrima:this.obDatosPrincipal.idSecPrima }

                    axios.post(`${BASE_URI}administrador/prima/listar`,o)
                         .then((r)=>{
                            if (_.get(r, ['data','existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data','data'], [])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                
                                var l = r.data.data;
                                var k = [
                                    {id:this.parametros.id_impuesto_scvs_wizard,t:'Impuesto SCVS'},
                                    {id:this.parametros.id_impuesto_ssc_wizard,t:'Impuesto SSC'},
                                    {id:this.parametros.id_impuesto_iva_wizard,t:'Impuesto IVA'}
                                ];

                                l.obImpuestos = _.map(l.obImpuestos,(v)=>{
                                                    v.nombre = _.get(_.find(k,{id:_.toNumber(v.id_impuesto)}),'t','N/A');
                                                    v.monto = _.toNumber(v.monto);
                                                    return v;
                                                });

                                this.setData('obForm.obImpuestos',_.get(l,'obImpuestos',{}));

                                l.obOtros = _.map(l.obOtros,(v)=>{
                                                v.nombre = _.startCase(v.tipo_parametro);
                                                v.valor_total = _.toNumber(v.valor_total);
                                                return v;
                                            });

                                this.setData('obForm.obOtros',_.get(l,'obOtros',{}));
                                this.setData('obForm.obPrima',_.get(l,'obPrima',{}));
                         })
                         .catch((e)=>{
                            mensajesAlerta(e,error);
                         });
                }
            },
            onListarImpuestos(event){
                if(!_.isUndefined(event)){
                    var error = 'E';
                    var o = {
                        opcion: "LISTAR_X_SEGURO_VEHICULO",
                        id_seguro: _.get(this.obDatosPrincipal,'idSeguro',null),
                        id_estado: _.get(this.parametros,'idEstadoDefault',null),
                        prima_bruta: this.obForm.prima_bruta
                    }

                    var k = [
                        {id:this.parametros.id_impuesto_scvs_wizard,t:'Impuesto SCVS'},
                        {id:this.parametros.id_impuesto_ssc_wizard,t:'Impuesto SSC'},
                        {id:this.parametros.id_impuesto_iva_wizard,t:'Impuesto IVA'}
                    ];

                    axios.post(`${BASE_URI}administrador/impuesto/listar`,o)
                         .then((r)=>{
                            if (_.get(r, ['data','existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data','data'], [])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                var l = _.cloneDeep(r.data.data);
                                l = _.map(l,(v)=>{
                                    v.nombre = _.get(_.find(k,{id:_.toNumber(v.id_impuesto)}),'t','N/A');
                                    v.monto = _.toNumber(v.monto);
                                    return v;
                                });
                                this.setData('obForm.obImpuestos',l);

                                return axios.post(`${BASE_URI}administrador/parametro-derecho-emision/listar`,o);
                         })
                         .then((r)=>{
                            if (_.get(r, ['data','existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data','data'], [])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                var l = _.cloneDeep(r.data.data);
                                l = _.map(l,(v)=>{
                                    v.nombre = _.startCase(v.tipo_parametro);
                                    v.valor_total = _.toNumber(v.valor_total);
                                    return v;
                                });
                                this.setData('obForm.obOtros',l);
                         })
                         .catch((e)=>{
                            mensajesAlerta(e,error);
                         });
                }
            },
            validar(){
                try {
                    if(!this.$refs.form.validate()) throw mensajeEstandar.corregirInformacion;
                        this.setData('obForm.obImpuestos',this.obImpuestos);
                        this.setData('obForm.obOtros',this.obOtros);
                        var obPrima = [
                            { tipo_prima: "prima_bruta", prima_bruta: this.obForm.prima_bruta },
                            { tipo_prima: "prima_neta", prima_neta: this.totalPrima },
                            { tipo_prima: "tasa_recarga", tasa_recarga: "0.00" }
                        ];

                        this.setData('obForm.obPrima',obPrima);

                        var obP = _.merge({},this.obDatosPrincipal,{'valorAsegurado':this.obForm.valorAsegurado});
                        this.setData('obForm.obPrincipal',obP);
                        this.setData('step',4)
                } catch (e) {
                    mensajesAlerta(e,'I');
                }
            }
        }
    }
</script>